export default __webpack_public_path__ + "static/media/Parallele-logo.bbcf28df.svg";